'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getResponsiveImageName = undefined;

var _browser = require('../../utils/services/browser');

var getResponsiveImageName = exports.getResponsiveImageName = function getResponsiveImageName(containerWidth, sizes) {
    var comparisonWidth = _browser.isRetina ? containerWidth * 2 : containerWidth;

    // Start with the largest
    return sizes.reduceRight(function (imageName, size) {
        if (size.width >= comparisonWidth) return size.name;
        return imageName;
    }, sizes[sizes.length - 1].name);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/imageHelper.js
// module id = 1984
// module chunks = 0